import React, { useContext } from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { useHistory, useParams } from "react-router-dom";
import { draftStore, sponsorsStore } from "../../store";
import NewDraft from "./newDraft";
import RoundSelect from "./roundSelect";
import RunningDraft from "./runningDraft";
import { Wrapper, Row, Col } from "../../components/layout";
import DraftResults from "./draftResults";
import Modal, { ModalContent } from "../../components/modal";
import { SecondaryButton } from "../../components/buttons";
import { setModalClose } from "../../actions/modal";
import { PresentedBy } from "../../components";
import { Separator } from "../../components/presentation";
import { mobileBreakpoint, baseUrl } from "../../lib";
import NavigationMenu from "../../components/navigationMenu";

const H1 = styled.h1`
  margin: 0;
`;

const HeaderWrapper = styled(Wrapper)`
  padding-top: 0px;
`;
const LogoRow = styled(Row)`
  position: relative;
`;

const PresentedByRow = styled(Row)`
  padding: 12px 0px 10px 0px;
`;

const DRAFT_STEPS = {
  1: <NewDraft />,
  2: <RoundSelect />,
  3: <RunningDraft />,
  4: <DraftResults />,
};

const RegularHeader = () => {
  const isMobile = useMediaQuery({ maxWidth: mobileBreakpoint });
  const goToHomepage = () => window.location.replace(baseUrl);
  const {
    state: { mockDraft },
  } = useContext(sponsorsStore);

  return (
    <>
      <LogoRow
        margin="20px 0 20px 0"
        justifyContent="space-between"
        alignItems="center"
      >
        <Col alignItems="center">{!isMobile && <H1>Start a new draft</H1>}</Col>
        <Col>
          <svg
            style={{ cursor: "pointer" }}
            width={isMobile ? "25px" : "35px"}
            height={isMobile ? "25px" : "35px"}
            viewBox="0 0 35 35"
            version="1.1"
            onClick={goToHomepage}
          >
            <g id="Icon/close/2px">
              <path
                d="M19.0909 0L0 19.0909L19.0909 0Z"
                transform="translate(7.954545 7.954545)"
                id="Path-3-Copy-4"
                fill="none"
                stroke="#d6001c"
                strokeWidth="2"
              />
              <path
                d="M19.0909 19.0909L0 0L19.0909 19.0909Z"
                transform="translate(7.954545 7.954545)"
                id="Path-3-Copy-5"
                fill="none"
                stroke="#d6001c"
                strokeWidth="2"
              />
            </g>
          </svg>
        </Col>
      </LogoRow>
      <Separator />
      {isMobile && (
        <>
          <PresentedByRow
            flexDirection="column"
            padding="10px 0px"
            justifyContent="space-between"
            alignItems="center"
          >
            <Col alignItems="center">
              <PresentedBy logo={mockDraft.url}></PresentedBy>
            </Col>
            <Col alignItems="center">
              <H1 style={{ lineHeight: "30px" }}>Start a new draft</H1>
            </Col>
          </PresentedByRow>
          <Separator />
        </>
      )}
    </>
  );
};

const getComponent = (step) => {
  switch (step) {
    case 1:
    case 2:
      return (
        <HeaderWrapper>
          <RegularHeader />
          {DRAFT_STEPS[step]}
        </HeaderWrapper>
      );
    case 3:
    case 4:
      return DRAFT_STEPS[step];
    default:
      return <></>;
  }
};

function MockDraft() {
  const { state, dispatch } = useContext(draftStore);
  const {
    status: { step },
    modal: { isOpen },
  } = state;
  let history = useHistory();
  let { draftId } = useParams();

  document.title = "Mock Draft Builder - FCHockey";

  return (
    <>
      <NavigationMenu />
      {draftId ? getComponent(4) : getComponent(step)}
      <Modal
        title="Quit the draft"
        isOpen={isOpen}
        closeModal={() => dispatch(setModalClose())}
      >
        <Row>
          <ModalContent>
            Your draft progress will be lost, are you sure you want to exit ?
          </ModalContent>
        </Row>
        <Row>
          <SecondaryButton
            padding="10px 50px"
            onClick={() => history.push("/mock-draft")}
          >
            Exit
          </SecondaryButton>
        </Row>
      </Modal>
    </>
  );
}

export default MockDraft;
